import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import Quill from 'quill';

@Directive({
  selector: 'quill-editor[preserveHtml]',
  exportAs: 'quillPreserveHtml'
})
export class QuillPreserveHtmlDirective implements OnDestroy, OnInit {
  private quillInstance: Quill | null = null;
  private currentContent: string = '';
  private contentLoaded: boolean = false;

  @Input() set preserveHtml(content: string) {
    this.currentContent = content || '';
    if (this.quillInstance && !this.contentLoaded && this.currentContent) {
      this.loadHtmlContent();
    }
  }

  constructor(private quillEditor: QuillEditorComponent) {
  }

  ngOnInit(): void {
    this.quillEditor.onEditorCreated.subscribe((quill: Quill) => {
      this.quillInstance = quill;
      if (this.currentContent && !this.contentLoaded) {
        this.loadHtmlContent();
      }
    });
  }

  private loadHtmlContent(): void {
    if (this.quillInstance && this.currentContent && !this.contentLoaded) {
      this.contentLoaded = true;
      setTimeout(() => {
        if (this.quillInstance && this.currentContent) {
          this.quillInstance.root.innerHTML = this.currentContent;
        }
      }, 0);
    }
  }

  public getHtmlContent(): string {
    if (this.quillInstance) {
      return this.quillInstance.root.innerHTML;
    }
    return '';
  }

  ngOnDestroy(): void {
    this.quillInstance = null;
  }
}